<template>
    <div class="container-fluid my-3 py-3">
        <div class="row my-3">
            <div class="col-6">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control"  v-model="plantDashboardRowColumn.name" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("component_name") }}</label>
                </div>
                
            </div>   
                         
        </div>
        <div class="row my-3">
            <div class="col-6">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control" v-model="plantDashboardRowColumn.position" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("position") }}</label>
                </div>
            </div>
        </div>
        <div class="text-danger" v-if="errors.length">
            <p v-for="error in errors" v-bind:key="error">{{ error }}</p>
        </div>
        <button class="btn btn-success mb-0 ms-auto" @click="submitForm">{{ $t("save") }}</button>
    </div>
</template>

<script>
import { createToast } from '@/assets/js/myToast.js'
import axios from 'axios'
export default {
    name: 'AddPlantDashboardRowColumn',
    emits: ['closeModal'],
    props: {
        dashboard: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            plantDashboardRowColumn: {
                name: '',
                position: '',
                is_chart: false
            },

            errors: [],
        }
    },
    mounted(){
        console.log('entry mounted')
        this.focusInput()
        console.log('exit mounted')
    },
    methods: {
        focusInput() {
            console.log('entry focusInput')
            console.log(this.$refs.name)
            this.$refs.name.focus();
            console.log('exit focusInput')
        },
        submitForm() {
            this.plantDashboardRowColumn.plant_dashboard = this.dashboard.id
            this.plantDashboardRowColumn.created_by = this.$store.state.me.id
            this.plantDashboardRowColumn.modified_by = this.$store.state.me.id
            
            axios
                .post(`/api/v1/plantdashboards_row_columns/`, this.plantDashboardRowColumn)
                .then(response => {
        
                    createToast({text: this.$t("row_column added")
                        ,type: 'success'})
                    this.plantDashboardRowColumn.name = ''

                this.$emit('closeModal', 'add', response.data)
                })
                .catch(error => {
                    if (error.response) {
                        for (const property in error.response.data) {
                            this.errors.push(`${property}: ${error.response.data[property]}`)
                        }

                        console.log(JSON.stringify(error.response.data))
                    } else if (error.message) {
                        console.log(JSON.stringify(error.message))
                    } else {
                        console.log(JSON.stringify(error))
                    }
                })
        }
    },
    computed:{
    }
}
</script>